import { useSelector } from 'react-redux'

const useLocale = () => {
  return useSelector((state) => state.locale)
}

export default useLocale
